//@ts-nocheck
// Customizable Area Start
import { IBlock } from "../../../../framework/src/IBlock";
import { Message } from "../../../../framework/src/Message";
import { BlockComponent } from "../../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../../framework/src/RunEngine";
import { RouterProps } from "react-router";
import { createRef } from 'react';
import { withAlertBoxProps } from "../../../../components/src/withAlertBox.Web";
import { withToastProps } from "../../../../components/src/withSnackBar.Web";
import { withLoaderProps } from "../../../../components/src/withLoader.Web";
export const configJSON = require("../config");
const { clientPortalURL } = require("../../../../framework/src/config");
import { client } from "../../../../components/src/HelloSignComponent.web";
import moment from "moment";
import { themeProps } from "../../../../web/src/theme2";
import { getPaymentPlan, getPaymentPlanForFlag } from "../packagePricing";
import { calculateTotalUpfrontAmount } from "../ClientList/ValueRoadmapController.web";
import { setTimeout } from "timers";

import {
  calculateMonthlyPaymentTerm,
  calculateQuaturlyPaymentTerm,
  calculateYearlyPaymentTerm,
  calculateSemiAnnualPaymentTerm,
  calculateDueOnCompletionPaymentTerm,
  calculateWeeklyPaymentTerm,
  calculateOneTimePaymentTerm,
} from "../ClientList/ValueRoadmapController.web";

const PackageManagementId = {
  DEFAULT_OBS: 14,
};
export const annual_packages = [
  "New Business Incubator",
  "IRS Rapid Relief Package",
  "Reporting-Only Package (Individual)",
  "Reporting-Only Package (Business)",
];
export const monthly_packages = [
  "Business Bundle",
  "Business Tax & Advisory",
  "Accounting Success Package",
  "Payroll Success Package",
  "Personal Bundle",
];
export type Props = RouterProps &
  withAlertBoxProps &
  withToastProps &
  withLoaderProps & {
    id: string;
    // Customizable Area Start
    // Customizable Area End
  };

interface S {
  // Customizable Area Start
  paymentaccesstoken: string | null;
  accountId: null;
  isEcheckPaymentAvailable: boolean;
  clientId: null;
  cpaDetail: unknown;
  clientDetail: null;
  cfsSurveyId: number | string;
  package_management_id: number | string | null;
  packageList: any[];
  selectedPackage: unknown;
  signatureRequests: any[];
  cpaSurveySetting: any;
  currentStep: number;
  isLoadingPage: boolean;
  checkListDetail: any;
  selectedCheckListId: number;
  availableCheckList: any[];
  checkListStepperIndex: {};
  section_question_index: number;
  currentSection: {};
  currentQuestion: {};
  onBoadringSurveyChecklistAnswer: {};
  surveyPaymentStatus: boolean;
  surveySignatureStatus: boolean;
  allReadySignedRequests: [];
  completeStatus: number;
  totalQuestions: number;
  saved_for_later: boolean;
  theme: any;
  isDefaultObsFlow: boolean;
  hasExistingClientData: boolean;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  country_code: string;
  clientToken:string;
  isSavingSurvey: boolean;
  isCheckingPaymentStatus: boolean;
  isCreatingChecklist: boolean;
  checklistCreationAttempted: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class OnBoardingSurveylandingPageController extends BlockComponent<
  Props,
  S,
  SS
> {
  getSignatureRequestCallId: string;
  getCPADetialbyAccessTokenCallId: string;
  saveOnBoardingSurveyApiCallId: string;
  checkSurveyPaymentStatusApiCallId: string;
  updateClientStatusCallId: string;
  getEmbedUrlCallId: string;
  updateOnboardingSurveyStatusCallId: string;
  updateCheckListApiCallId: string;
  saveDocumentSignntureApiCallId: string;
  collectPaymentApiCallId: string;
  getsignDocsCallId : string;
  createClientForDefaultObsApiCallId: string;
  getClientDetailsForDefaultObsApiCallId: string;
  createChecklistforSelectedPackageApiCallId: string;
  getClientDetailCallId:string=''
  isEcheckPaymentAvailableCallId: string;
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.AlertMessage),
      // Customizable Area End
    ];

    this.state = {
      paymentaccesstoken: null,
      accountId: null,
      isEcheckPaymentAvailable: false,
      clientId: null,
      cpaDetail: null,
      clientDetail: null,
      currentStep: null,
      signatureRequests: [],
      cfsSurveyId: null,
      package_management_id: null,
      packageList: [],
      cpaSurveySetting: null,
      selectedPackage: null,
      isLoadingPage: false,
      checkListDetail: null,
      selectedCheckListId: null,
      availableCheckList: [],
      checkListStepperIndex: {},
      section_question_index: 0,
      currentSection: {},
      currentQuestion: {},
      onBoadringSurveyChecklistAnswer: {},
      surveyPaymentStatus: false,
      surveySignatureStatus: false,
      allReadySignedRequests: [],
      completeStatus: 0,
      totalQuestions: 0,
      saved_for_later: false,
      custom_portal_url: null,
      theme: themeProps,
      isDefaultObsFlow: false,
      hasExistingClientData: false,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      country_code: "+1",
      clientToken:'',
      isSavingSurvey: false,
      isCheckingPaymentStatus: false,
      isCreatingChecklist: false,
      checklistCreationAttempted: false
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  handleApiError = (responseJson) => {
    if (typeof responseJson?.errors === "string") {
      this.props.showToast({
        type: "error",
        message: "Some internal error",
      });
      this.setState({
        isEnable: true,
      });
    } else {
      this.parseApiErrorResponse(responseJson);
    }
  };
  handleSignatureRequestResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson.data && responseJson.data.length > 0) {
      const signatureRequests = [];
      responseJson.data.forEach((sign) => {
        const temp = {
          id: sign.id,
          document: sign.attributes.document,
          document_template_title: sign.attributes.document_template_title,
          submitted: sign.attributes.submitted,
          survey_id: sign.attributes.survey_id,
          document_template_id : sign.attributes.document_template_id,
          signed_token: sign.attributes.signed_embed_token,
          docuseal_submission_slug: sign.attributes.docuseal_submission_slug
        };
        signatureRequests.push(temp);
      });
      this.setState({
        signatureRequests,
      });
    } else {
      this.handleApiError(responseJson);
    }
  };
  handleUpdateCheckListResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson?.message) {
      const totalQuestionCount = this.state.totalQuestions;
      let totalAnsweCount = 0;
      Object.keys(this.state.onBoadringSurveyChecklistAnswer).forEach(
        (questionKey) => {
          if (this.state.onBoadringSurveyChecklistAnswer[questionKey]?.answer) {
            totalAnsweCount++;
          }
        }
      );
      this.setState(
        {
          completeStatus: Math.round(
            (totalAnsweCount / totalQuestionCount) * 100
          ),
        },
        () => {
          this.getNextQuestion();
        }
      );
    } else {
      this.handleApiError(responseJson);
    }
  };
  setDocumentTitleAndIcon = () => {
    if (
      this.state.cpaDetail?.theme?.logo
    ) {
      const canvasOBS = document.createElement("canvas");
      canvasOBS.width = 160;
      canvasOBS.height = 160;
      const ctx = canvasOBS.getContext("2d");
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src =
        this.state.cpaDetail.theme.logo;
      img.onload = this.onImageLoadForOBS.bind(this, ctx, img, canvasOBS);

    }

    if (this.state.cpaDetail?.theme?.firm_name) {
      document.title = this.state.cpaDetail.theme.firm_name;
    }
  };
  onImageLoadForOBS = function (ctx, img, canvas) {
    ctx.drawImage(img, 0, 0);
    let linkOBS = document.querySelector("link[rel~='icon']");
    if (!linkOBS) {
      linkOBS = document.createElement("link");
      linkOBS.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(linkOBS);
    }
    linkOBS.href = canvas.toDataURL("image/x-icon");
  };
  handleCPADetialbyAccessTokenResponse = (responseJson) => {
    this.props.hideLoader();
    if (
      responseJson &&
      responseJson?.data &&
      responseJson?.data?.id &&
      responseJson?.data?.attributes
    ) {
      this.setState(
        {
          cpaDetail: responseJson?.data?.attributes,
          paymentaccesstoken:
            responseJson?.data?.attributes?.cpa_charge_access_token,
          cpaSurveySetting:
            responseJson?.data?.attributes?.custom_survey_setting?.data
              ?.attributes,
        },
        () => {
          this.setDocumentTitleAndIcon();
          this.setTheme(responseJson.data.attributes.theme);
          if (this.state.isDefaultObsFlow) {
            const savedSurveyId = sessionStorage.getItem('defaultObsSurveyId');
            const savedClientId = sessionStorage.getItem('defaultObsClientId');

            if (this.state.cfsSurveyId || savedSurveyId) {
             
              const surveyId = this.state.cfsSurveyId || parseInt(savedSurveyId);
              const clientId = this.state.clientId || parseInt(savedClientId);

              this.setState({
                cfsSurveyId: surveyId,
                clientId: clientId,
                isLoadingPage: false,
              }, () => {
                this.checkSurveyPaymentStatus();
              });
            } else if (this.state.clientId) {
              this.getClientDetailsForDefaultObs();
            } else {
              this.setState({
                currentStep: -1,
                isLoadingPage: false,
              });
            }
          } else {
            this.saveOnBoardingSurvey();
            this.updateOnboardingSurveyStatus("Signature & Payment Pending");
          }
        }
      );
    } else {
      this.handleApiError(responseJson);
    }
  };
  moveToPaymentStep = (responseJson, packageList, selectedPackage) => {
    this.setState(
      {
        currentStep: this.state?.cpaDetail?.cpa_charge_info ? 2 : 3,
        packageList: packageList,
        isLoadingPage: false,
        package_management_id: this.state.roadmap_id
          ? this.state.custom_package_id
          : responseJson.data.attributes.package?.data?.id,
        selectedPackage: selectedPackage,
        availableCheckList:
          responseJson?.data?.attributes?.checklists?.data || [],
      },
      () => {
        if (this.state.currentStep == 3) {
          const answer = this.getAnswerOfEachQuestion(
            responseJson.data.attributes.checklists?.data
          );
          this.setState(
            {
              onBoadringSurveyChecklistAnswer:
                answer?.onBoadringSurveyChecklistAnswer,
              completeStatus: Math.round(
                (answer?.totalAnswerCount / answer?.totalQuestionCount) * 100
              ),
              totalQuestions: answer?.totalQuestionCount,
            },
            () => {
              const availableCheckList = [];
              const checkListStepperIndex = {};
              this.state?.checkListDetail &&
                this.state?.checkListDetail.length > 0 &&
                this.state?.checkListDetail?.forEach((checklist) => {
                  availableCheckList.push({ ...checklist });
                  checkListStepperIndex[checklist?.id] = checkListStepperIndex[
                    checklist?.id
                  ]
                    ? checkListStepperIndex[checklist?.id]
                    : 0;
                });
              this.setState({
                availableCheckList: availableCheckList,
                checkListStepperIndex: checkListStepperIndex,
              });
            }
          );
        }
      }
    );
  };
  moveToSignatureStep = (responseJson, packageList, selectedPackage) => {
    this.setState(
      {
        currentStep: 1,
        packageList: packageList,
        isLoadingPage: false,
        package_management_id: this.state.roadmap_id
          ? this.state.custom_package_id
          : responseJson.data.attributes.package?.data?.id,
        selectedPackage: selectedPackage,
        availableCheckList:
          responseJson?.data?.attributes?.checklists?.data || [],
      },
      () => {
        this.getSignatureRequest();
      }
    );
  };

  getClientDetail = () => {
    if (!this.state.clientId) {
      return;
    }

    const headers = {
      "content-type": "application/json",
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    this.getClientDetailCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_informations/${this.state.clientId}/get_client_details`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      "getClientDetailSuccess"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceErrorMessage),
      "getClientDetailError"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // getClientDetailResponse = (responseJson) => {
  //  const clientToken = responseJson?.data?.attributes?.client_token;

  //  this.setState({ clientToken });

  //   if (clientToken) {
  //     window.open(
  //       `http://localhost:3000/${localStorage.getItem('accountId')}/${localStorage.getItem('firmName')}?token=${clientToken}`
  //       // https://app.mytaxdashboard.com/${accountId}/${firmName}
  //     );
  //   }
  // };
  getClientDetailResponse = (responseJson) => {
    const clientToken = responseJson?.data?.attributes?.client_token;

    this.setState({ clientToken });

if (clientToken) {
      const accountId = this.state.accountId || localStorage.getItem("accountId");
      const firmName = this.state.cpaDetail?.theme?.firm_name || localStorage.getItem("firmName");

      if (!accountId || !firmName) {
        console.warn("Client portal redirect missing params", { accountId, firmName });
      }

      const portalUrl = new URL(`${accountId}/${firmName}`, clientPortalURL);
      
      portalUrl.searchParams.set("token", clientToken);
      window.location.href = portalUrl.toString();
    }
  };


  getAlReadySignedRequests = (responseJson) => {
    let allreadysigneddocs = [];
    if (responseJson.data.attributes.document_signed?.length > 0) {
      allreadysigneddocs = responseJson.data.attributes.document_signed
        .filter((sign) => {
          return sign.status;
        })
        .map((document) => {
          const temp = {};
          temp["template_id"] = document?.document_template_id;
          temp["fileName"] = null;
          temp["signature_id"] = document?.signature;
          temp["signature_url"] = null;
          return temp;
        });
    }
    return allreadysigneddocs;
  };
  getAvbleChecklist = (checkListDetail) => {
    const availableCheckList = [];
    const checkListStepperIndex = {};
    checkListDetail &&
      checkListDetail.length > 0 &&
      checkListDetail?.forEach((checklist) => {
        availableCheckList.push({ ...checklist });
        checkListStepperIndex[checklist?.id] = checkListStepperIndex[
          checklist?.id
        ]
          ? checkListStepperIndex[checklist?.id]
          : 0;
      });
    availableCheckList?.forEach((checklist) => {
      const sections = checklist?.attributes?.sections?.data;
      sections?.forEach((section) => {
        const questions = section?.attributes?.questions?.data;
        section.attributes.questions.data = questions;
      });
    });
    return { availableCheckList, checkListStepperIndex };
  };
  getCheckListDetail = (responseJson) => {
    const checkListDetail =
      responseJson?.data?.attributes?.checklists?.data || [];
    if (checkListDetail?.length > 0) {
      return this.getAvbleChecklist(checkListDetail);
    } else {
      // For CFS surveys, don't create checklist yet.
      // Wait until user completes signature/payment step.
      const isCfSSurvey = this.state.cfsSurveyId && !this.state.roadmap_id;
      const shouldSkipPackageSelection = isCfSSurvey;

      if (shouldSkipPackageSelection) {
        return null;
      }

      if (responseJson?.data?.attributes?.package?.data?.id && !this.state.checklistCreationAttempted) {
        this.createChecklistforSelectedPackage(
          responseJson?.data?.attributes?.package?.data?.id
        );
      }
    }
  };
  handleCheckSurveyPaymentStatusResponse = (responseJson) => {
    this.props.hideLoader();
    this.setState({ isCheckingPaymentStatus: false });

    if (responseJson?.data?.attributes) {
      this.setState(
        {
          allReadySignedRequests: this.getAlReadySignedRequests(responseJson),
        },
        () => {
          this.handdleNextResponse(responseJson);
        }
      );
    } else {
      this.parseApiErrorResponse(responseJson);
    }
  };
  handleCreateChecklistResponse = (responseJson) => {
    this.props.hideLoader();
    this.setState({ isCreatingChecklist: false });

    if (responseJson?.data || responseJson?.message) {
      if (this.state.cfsSurveyId && !this.state.isDefaultObsFlow) {
        this.checkSurveyPaymentStatus(this.state.cfsSurveyId);
      }
    } else {
      this.props.showToast({
        type: "error",
        message: responseJson?.errors?.[0] || "Failed to create checklist",
      });
    }
  };
  handleNextRoadmapResponse = (responseJson, packageList) => {
    let package_management_id = null;
    let selectedPackage = null;
    let surveyPaymentStatus = null;
    if (responseJson.data.attributes.roadmap) {
      if (responseJson.data.attributes.roadmap.data) {
        if (responseJson.data.attributes.roadmap.data.attributes) {
          const roadmapData = responseJson.data.attributes.roadmap.data.attributes;
          surveyPaymentStatus =
            responseJson.data.attributes.payment_status || roadmapData?.obs?.schedule?.id;
          const custom_packages = roadmapData?.custom_packages?.data;

          if (custom_packages && custom_packages.length > 0) {
            custom_packages.forEach((pkg, index) => {
              calculateMonthlyPaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
              calculateQuaturlyPaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
              calculateYearlyPaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
              calculateSemiAnnualPaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
              calculateDueOnCompletionPaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
              calculateWeeklyPaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
              calculateOneTimePaymentTerm(
                pkg?.attributes?.payment_term,
                packageList,
                pkg
              );
            });
            selectedPackage = packageList.find((pkg) => {
              return (
                pkg.paymentTermKey + "_" + pkg?.pkg?.id ==
                this.state.payment_term + "_" + this.state.custom_package_id
              );
            });
            package_management_id = this.state.custom_package_id;
          }
        }
      }
    }
    return {
      selectedPackage,
      package_management_id,
      packageList,
      surveyPaymentStatus,
    };
  };
  handdleNextResponse = (responseJson) => {
    let surveySignStatus = this.getSignStatus(responseJson);
    let surveyPaymentStatus = responseJson.data.attributes.payment_status;
    let packageList = [];
    let package_management_id = null;
    let selectedPackage = null;
    if (this.state.roadmap_id) {
      const a = this.handleNextRoadmapResponse(responseJson, packageList);
      packageList = a.packageList;
      selectedPackage = a.selectedPackage;
      package_management_id = a.package_management_id;
      surveyPaymentStatus = a.surveyPaymentStatus;
    } else {
      packageList =
        responseJson.data.attributes.survey_packages?.data?.attributes
          ?.packages || [];
      package_management_id =
        responseJson.data.attributes.package?.data?.id || null;
      selectedPackage = responseJson.data.attributes.package?.data || null;
      if (!surveyPaymentStatus) {
        surveyPaymentStatus = responseJson.data.attributes.survey_packages?.data?.attributes?.recurring_charge?.id
      }
    }

    const chklist = this.getCheckListDetail(responseJson);
    const surveySettings = responseJson.data.attributes.survey_settings;
    this.setState(
      {
        surveyPaymentStatus: surveyPaymentStatus,
        surveySignatureStatus: surveySignStatus,
        packageList: packageList,
        isLoadingPage: false,
        package_management_id: package_management_id,
        selectedPackage: selectedPackage,
        checkListDetail: responseJson.data.attributes.checklists?.data || [],
        availableCheckList: chklist?.availableCheckList || [],
        checkListStepperIndex: chklist?.checkListStepperIndex || {},
        custom_portal_url: surveySettings?.data?.attributes?.custom_portal_url,
      },
      () => {
        this.movetoNextStep(responseJson, packageList, selectedPackage);
      }
    );
  };
  movetoNextStep = (responseJson, packageList, selectedPackage) => {
    if (this.state.isDefaultObsFlow) {
      if (this.state.currentStep >= 3) {
        return;
      }
      if (this.state.currentStep !== 1) {
        this.moveToSignatureStep(responseJson, packageList, selectedPackage);
        return;
      }
    }

    if (this.state.currentStep >= 3) {
      return;
    }

    const isAlreadyPastSignatureStep = this.state.currentStep >= 2;

    if (
      isAlreadyPastSignatureStep &&
      this.state?.surveyPaymentStatus &&
      this.state.checkListDetail?.length > 0
    ) {
      this.updateClientStatus("Enrolled");
      this.updateOnboardingSurveyStatus("Enrolled");
      this.moveToChecklistPage(responseJson, packageList, selectedPackage);
    } else if (this.state?.surveyPaymentStatus && this.state.surveySignatureStatus) {
      this.updateClientStatus("Enrolled");
      this.updateOnboardingSurveyStatus("Enrolled");
      this.moveToChecklistPage(responseJson, packageList, selectedPackage);
    } else if (
      !this.state?.surveyPaymentStatus &&
      this.state.surveySignatureStatus
    ) {
      this.moveToPaymentStep(responseJson, packageList, selectedPackage);
    } else if (
      this.state?.surveyPaymentStatus &&
      !this.state.surveySignatureStatus &&
      !isAlreadyPastSignatureStep
    ) {
      this.moveToSignatureStep(responseJson, packageList, selectedPackage);
    } else if (
      !this.state?.surveyPaymentStatus &&
      !this.state.surveySignatureStatus &&
      !isAlreadyPastSignatureStep
    ) {
      this.moveToSignatureStep(responseJson, packageList, selectedPackage);
    }
  };
  getSignStatus = (responseJson) => {
    const allDocstobeSigned =
      responseJson.data.attributes?.document_signed || [];
    let surveySignStatus = false;
    if (allDocstobeSigned.length > 0) {
      if (
        this.state.allReadySignedRequests.length == allDocstobeSigned.length
      ) {
        surveySignStatus = true;
      }
    }
    return surveySignStatus;
  };
  moveToChecklistPage = (responseJson, packageList, selectedPackage) => {
    const answer = this.getAnswerOfEachQuestion(
      responseJson.data.attributes.checklists?.data
    );
    this.setState(
      {
        currentStep: 3,
        packageList: packageList,
        isLoadingPage: false,
        package_management_id: this.state.roadmap_id
          ? this.state.custom_package_id
          : responseJson.data.attributes.package?.data?.id,
        selectedPackage: selectedPackage,
        checkListDetail: responseJson.data.attributes.checklists?.data || [],
        onBoadringSurveyChecklistAnswer:
          answer?.onBoadringSurveyChecklistAnswer,
        completeStatus: Math.round(
          (answer?.totalAnswerCount / answer?.totalQuestionCount) * 100
        ),
        totalQuestions: answer?.totalQuestionCount,
      },
      () => {
        const availableCheckList = [];
        const checkListStepperIndex = {};
        this.state?.checkListDetail &&
          this.state?.checkListDetail.length > 0 &&
          this.state?.checkListDetail?.forEach((checklist) => {
            availableCheckList.push({ ...checklist });
            checkListStepperIndex[checklist?.id] = checkListStepperIndex[
              checklist?.id
            ]
              ? checkListStepperIndex[checklist?.id]
              : 0;
          });
        this.setState({
          availableCheckList: availableCheckList,
          checkListStepperIndex: checkListStepperIndex,
        });
      }
    );
  };
  updateOnboardingSurveyStatusResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson?.message) {
      this.props.showToast({
        type: "success",
        message: responseJson?.message,
      });
    } else {
      this.handleApiError(responseJson);
    }
  };
  handleEmbeedurlResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson?.data) {
      client.open(responseJson?.data);
    } else {
      this.handleApiError(responseJson);
    }
  };

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.RestAPIResponceMessage)) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (this.saveForLaterApiCallId == apiRequestCallId) {
        this.handleSaveForlaterResponse(responseJson);
      } else if (apiRequestCallId === this.getEmbedUrlCallId) {
        this.handleEmbeedurlResponse(responseJson);
      } else if (apiRequestCallId === this.getSignatureRequestCallId) {
        this.handleSignatureRequestResponse(responseJson);
      } else if (this.updateCheckListApiCallId === apiRequestCallId) {
        this.handleUpdateCheckListResponse(responseJson);
      } else if (this.getCPADetialbyAccessTokenCallId === apiRequestCallId) {
        this.handleCPADetialbyAccessTokenResponse(responseJson);
      } else if (this.checkSurveyPaymentStatusApiCallId === apiRequestCallId) {
        this.handleCheckSurveyPaymentStatusResponse(responseJson);
      } else if (this.collectPaymentApiCallId === apiRequestCallId) {
        this.handlePaymentAPiResponse(responseJson);
      } else if (this.saveOnBoardingSurveyApiCallId === apiRequestCallId) {
        this.saveOnBoardingSurveyResponse(responseJson);
      } else if (this.saveDocumentSignntureApiCallId === apiRequestCallId) {
        this.saveDocumentSignntureResponse(responseJson);
      } else if (this.updateOnboardingSurveyStatusCallId == apiRequestCallId) {
        this.updateOnboardingSurveyStatusResponse(responseJson);
      }
      else if(this.getsignDocsCallId == apiRequestCallId){
        this.getSignatureRequest()
      } else if(this.createClientForDefaultObsApiCallId == apiRequestCallId){
        this.handleCreateClientForDefaultObsResponse(responseJson)
      } else if(this.getClientDetailsForDefaultObsApiCallId == apiRequestCallId){
        this.handleGetClientDetailsForDefaultObsResponse(responseJson)
      } else if(this.createChecklistforSelectedPackageApiCallId == apiRequestCallId){
        this.handleCreateChecklistResponse(responseJson)
      } else if (this.isEcheckPaymentAvailableCallId === apiRequestCallId) {
        this.isEcheckPaymentAvailableResponse(responseJson);
      }
      if(apiRequestCallId==this.getClientDetailCallId){
        this.getClientDetailResponse(responseJson) 
      }
    } else if (getName(MessageEnum.AlertMessage) === message.id) {
      const AlertBodyMessage = message.getData(
        getName(MessageEnum.AlertBodyMessage)
      );
      this.props.showToast({
        type: "error",
        message: AlertBodyMessage,
      });
    }
  }
  handleSaveForlaterResponse = (responseJson) => {
    this.props.hideLoader();
    this.props.showToast({
      message: "Your response save successfully",
      type: "message",
    });
    setTimeout(() => {
      window.close();
    }, 1000);
  };
  saveOnBoardingSurveyResponse = (responseJson) => {
    this.props.hideLoader();
    this.setState({ isSavingSurvey: false });

    if (responseJson?.data?.id) {
      const surveySettings = responseJson?.data.attributes.survey_settings;
      const package_management_id = responseJson?.data?.attributes.custom_package_management_id || responseJson?.data?.attributes.package_management_id;
      this.setState(
        {
          onboarding_survey_id: responseJson?.data?.id,
          package_management_id: package_management_id,
          custom_package_id: responseJson?.data?.attributes.custom_package_management_id || this.state.custom_package_id,
          saved_for_later: responseJson?.data?.attributes?.saved_for_later,
          custom_portal_url: surveySettings?.data.attributes.custom_portal_url,
        },
        () => {
          if (this.state.saved_for_later) {
            this.props.showToast({
              type: "error",
              message:
                "you can access this survey using our clinet portal.we have sent a mail to registered email id",
            });
            if (window.location.href.indexOf("dev") > -1) {
              window.location.href =
                "https://smartpathclientportal-271175-react.b271175.dev.eastus.az.svc.builder.cafe";
            } else if (window.location.href.indexOf("stage") > -1) {
              window.location.href =
                "https://smartpathclientportal-271175-react.b271175.stage.eastus.az.svc.builder.ai";
            }
          } else {
            this.checkSurveyPaymentStatus(this.state.cfsSurveyId);
          }
        }
      );
    } else {
      this.setState({ isLoadingPage: false });
      this.handleApiError(responseJson);
    }
  };
  saveDocumentSignntureResponse = (responseJson) => {
    this.props.hideLoader();
    if (responseJson?.data?.id) {
      const signatureRequests = [...this.state.signatureRequests];
      const index = signatureRequests.findIndex((signatureRequest) => {
        return (
          signatureRequest?.template_id ===
          responseJson?.data?.document_template_id
        );
      });
      signatureRequests[index] = {
        ...signatureRequests[index],
        isSigned: true,
      };
      this.setState({
        signatureRequests: signatureRequests,
      });
    }
  };
  handleRecurringPayment = (responseJson) => {
    if (responseJson?.data?.attributes?.schedule?.id) {
      this.checkSurveyPaymentStatus();
      this.props.showToast({
        type: "success",
        message: "payment scheduled successfully",
      });
      return true;
    } else {
      this.handleApiError(responseJson);
    }
    return false;
  };
  handlePaymentAPiResponse = (responseJson) => {
    this.props.hideLoader();
    if (this.state.roadmap_id) {
      this.handleRecurringPayment(responseJson);
    } else {
      if (!this.handleRecurringPayment(responseJson)) {
        if (responseJson?.data?.attributes?.transaction_id) {
          this.checkSurveyPaymentStatus();
          this.props.showToast({
            type: "success",
            message: "payment completed successfully",
          });
        } else {
          this.handleApiError(responseJson);
        }
      }
    }
  };
  handleDocumentSigned = (documentId?: number) => {
    if (documentId) {
      const signatureRequests = [...this.state.signatureRequests];
      const index = signatureRequests.findIndex((sign) => sign.id === documentId);

      if (index !== -1) {
        signatureRequests[index] = {
          ...signatureRequests[index],
          submitted: true,
        };
        this.setState({ signatureRequests });
      }
    }

    this.getSignatureRequest();
  };

  getSignatureRequest = () => {
    this.props.showLoader();

    const headers = {
      "content-type": "application/json",
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getSignatureRequestCallId = requestMessage.messageId;
    let url;
    if (this.state.cfsSurveyId) {
      url = `bx_block_pricingcalculator/client_information_onboardings/document_signatures?survey_id=${this.state.cfsSurveyId}&client_id=${this.state.clientId}&account_id=${this.state.accountId}`;
    } else {
      url = `bx_block_pricingcalculator/client_information_onboardings/document_signatures_for_roadmap?road_customization_id=${this.state.roadmap_id}&client_id=${this.state.clientId}&account_id=${this.state.accountId}`;
    }
    if (this.state.package_management_id && this.state.cfsSurveyId) {
      url += `&package_management_id=${this.state.package_management_id}`;
    }
    if (this.state.package_management_id && this.state.roadmap_id) {
      url += `&custom_package_id=${this.state.package_management_id}&parent_package_type=${this.state.parent_package_type}`;
    }

    if (!this.state?.cpaDetail?.cpa_charge_info) {
      url += `&cpa_not_enabled=true`;
    }
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };



  getsignDocs = ( survey_id, document_template_id) => {

    this.props.showLoader();

    const headers = {
      "content-type": "application/json",
       "token":localStorage.getItem("authToken")
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getsignDocsCallId = requestMessage.messageId;
    let url = `bx_block_client_dashboard/sign_document?document_template_id=${document_template_id}&client_id=${this.state.clientId}`;
    if (this.state.roadmap_id) {
      url += `&road_customization_id=${this.state.roadmap_id}`;
    } else if (survey_id) {
      url += `&survey_id=${survey_id}`;
    }

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      'PUT'
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  
  
  
  getEmbedUrl = (signatureRequest_id, document_template_id) => {
    this.setState(
      {
        document_template_id: document_template_id,
      },
      () => {
        this.props.showLoader();

        const headers = {
          "content-type": "application/json",
        };

        const requestMessage = new Message(
          getName(MessageEnum.RestAPIRequestMessage)
        );

        this.getEmbedUrlCallId = requestMessage.messageId;

        requestMessage.addData(
          getName(MessageEnum.RestAPIResponceEndPointMessage),
          `bx_block_pricingcalculator/client_information_onboardings/sign_url?signature=${signatureRequest_id}`
        );

        requestMessage.addData(
          getName(MessageEnum.RestAPIRequestHeaderMessage),
          JSON.stringify(headers)
        );

        requestMessage.addData(
          getName(MessageEnum.RestAPIRequestMethodMessage),
          "GET"
        );

        runEngine.sendMessage(requestMessage.id, requestMessage);
      }
    );
  };
  setTheme = (theme1) => {
    localStorage.setItem(
      "themePrimaryColor",
      theme1.primary_color || themeProps?.palette?.primary?.main
    );
    localStorage.setItem(
      "themeSecondaryColor",
      theme1.secondary_color || themeProps?.palette?.primary?.main
    );
    this.setState({
      theme: {
        ...themeProps,
        palette: {
          ...themeProps?.palette,
          primary: {
            main: theme1.primary_color || themeProps?.palette?.primary?.main,
          },
          secondary: {
            main: "#444040",
          },
        },
        overrides: {
          ...themeProps.overrides,
          MuiButton: {
            ...themeProps.overrides.MuiButton,
            containedPrimary: {
              ...themeProps.overrides.MuiButton.containedPrimary,
              fontSize: "0.8rem",
            },
            textPrimary: {
              ...themeProps.overrides.MuiButton.textPrimary,
              color: theme1.primary_color,
            },
            outlinedPrimary: {
              ...themeProps.overrides.MuiButton.outlinedPrimary,
              color: theme1.primary_color,
            },
          },
          MuiOutlinedInput: {
            ...themeProps.overrides.MuiOutlinedInput,
            root: {
              ...themeProps.overrides.MuiOutlinedInput.root,
              "&.Mui-focused": {
                border: `2px solid ${theme1.primary_color ||
                  themeProps?.palette?.primary?.main}`,
                backgroundColor: "#fff",
              },
            },
          },
        },
      },
    });
  };

  isEcheckPaymentAvailable = () => {
    const headers = {
      "content-type": "application/json",
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.isEcheckPaymentAvailableCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_survey/payments/accept_e_check?account_id=${this.state.accountId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  isEcheckPaymentAvailableResponse = (responseJson) => {
    this.setState({
      isEcheckPaymentAvailable: responseJson?.status === true,
    });
  };

  getCPADetialbyAccessToken = () => {
    this.props.showLoader();

    const headers = {
      "content-type": "application/json",
    };
    const data = {
      data: {
        attributes: {
          access_token: "",
          account_id: this.state.accountId || "",
        },
      },
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getCPADetialbyAccessTokenCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `account_block/accounts/access_token`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  checkSurveyPaymentStatus = (survey_id: number) => {
    if (this.state.isCheckingPaymentStatus) {
      return;
    }

    this.setState({ isCheckingPaymentStatus: true });
    this.props.showLoader();
    const headers = {
      "content-type": "application/json",
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.checkSurveyPaymentStatusApiCallId = requestMessage.messageId;
    let url = `bx_block_pricingcalculator/client_information_onboardings/onboarding_survey?client_id=${this.state.clientId}&account_id=${this.state.accountId}`;
    if (this.state.cfsSurveyId) {
      url += `&survey_id=${this.state.cfsSurveyId}`;
      if (this.state.package_management_id) {
        url += `&package_management_id=${this.state.package_management_id}`;
      }
    } else if (this.state.roadmap_id) {
      url += `&road_customization_id=${this.state.roadmap_id}`;
      if (this.state.custom_package_id) {
        url += `&custom_package_id=${this.state.custom_package_id}&parent_package_type=${this.state.parent_package_type}`;
      }
    }

    // &package_management_id=${}
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      url
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  getPaymentTerm = (oldPaymentTerm) => {
    if (oldPaymentTerm == "is_monthly_selected") {
      return "MONTH";
    } else if (oldPaymentTerm == "is_quarterly_selected") {
      return "quarter";
    } else if (oldPaymentTerm == "is_yearly_selected") {
      return "year";
    } else if (oldPaymentTerm == "is_weekly_selected") {
      return "week";
    } else if(oldPaymentTerm == "is_semi_annual_selected"){
      return "semi_annually";
    } else if(oldPaymentTerm == "is_due_on_completion_selected"){
      return "due_on_completion";
    } else if(oldPaymentTerm == "is_one_time_selected"){
      return "one_time";
    }
  };
  // packageList holds two different shapes. On a roadmap it holds the entries built by
  // the calculate*PaymentTerm helpers ({ paymentTermKey, value, pkg }); on a survey it
  // holds the packages the API returned ({ payment_terms, total_amount }). Both flows can
  // reach here at once, because cfsSurveyId is restored from storage while roadmap_id
  // comes from the URL, and reading the survey fields off a roadmap entry yields
  // undefined - which used to send amount: NaN and now would send a $0 charge.
  getSelectedPlan = (selectedPackage) => {
    const roadmapTerm = selectedPackage.pkg?.attributes?.payment_term;
    if (!roadmapTerm) {
      return getPaymentPlan(
        selectedPackage.payment_terms,
        selectedPackage.total_amount
      );
    }

    // Whatever is collected up front is charged separately, so it is not part of the
    // instalment - same split the roadmap card displays.
    const upfront = calculateTotalUpfrontAmount(roadmapTerm);
    return getPaymentPlanForFlag(
      selectedPackage.paymentTermKey,
      Number(roadmapTerm.total_amount) - upfront.totalUpfrontAmount
    );
  };

  getSelectPkg = () => {
    return this.state.roadmap_id
      ? this.state.packageList.find((pkg) => {
        return (
          pkg.paymentTermKey + "_" + pkg.pkg.id ==
          this.state.payment_term + "_" + this.state.custom_package_id
        );
      })
      : this.state.packageList.find((pkg) => {
        return pkg.id == this.state.package_management_id;
      });
  }

  collectPayment = (methodId, methodType) => {
    this.props.showLoader();
    const headers = {
      "content-type": configJSON.validationApiContentType,
      // token: lo,
    };
    const selectedPackage = this.getSelectPkg()
    if (selectedPackage) {
      const plan = this.getSelectedPlan(selectedPackage);
      const packageId = selectedPackage.pkg?.id ?? selectedPackage.id;
      const surveyData =
        plan.recurring
          ? {
            data: {
              attributes: {
                package_id: packageId,
                amount: Math.round(plan.price),
                survey_id: this.state.cfsSurveyId,
                method: methodId,
                method_type: methodType,
                account_id: this.state.accountId,
                payment_term: plan.paymentTerm,
              },
            },
          }
          : {
            data: {
              attributes: {
                package_id: packageId,
                amount: Math.round(plan.price),
                survey_id: this.state.cfsSurveyId,
                access_token: this.state.paymentAccessToken,
                method: methodId,
                method_type: methodType,
                account_id: this.state.accountId,
              },
            },
          };

      const data = this.state.cfsSurveyId
        ? surveyData
        : {
          data: {
            attributes: {
              custom_package_id: selectedPackage.pkg.id,
              amount:
                selectedPackage.value.indexOf("Upfront") > -1
                  ? Math.round(
                    parseFloat(
                      selectedPackage.value
                        .split("+")[1]
                        .split(" ")[2]
                        .replace(/,/g, "")
                    )
                  )
                  : Math.round(
                    parseFloat(
                      selectedPackage.value.split(" ")[1].replace(/,/g, "")
                    )
                  ),
              road_customization_id: this.state.roadmap_id,
              access_token: this.state.paymentaccesstoken,
              method: methodId,
              account_id: this.state.accountId,
              payment_term: this.getPaymentTerm(this.state.payment_term),
              upfront_amount:
                selectedPackage.value.indexOf("Upfront") > -1
                  ? Math.round(
                    parseFloat(
                      selectedPackage.value
                        ?.split("+")[0]
                        .split(" ")[1]
                        .replace(/,/g, "")
                    )
                  )
                  : 0,
            },
          },
        };
      // this.state.payment_term
      const requestMessage = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );

      this.collectPaymentApiCallId = requestMessage.messageId;
      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        !this.state.roadmap_id
          ? `bx_block_survey/payments`
          : "bx_block_survey/create_payment_for_roadmap"
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(headers)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(data)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        "POST"
      );
      runEngine.sendMessage(requestMessage.id, requestMessage);
    }
  };

  saveDocumentSignnture = (signature) => {
    this.props.showLoader();
    const headers = {
      "content-type": configJSON.validationApiContentType,
      // token: lo,
    };
    const data = this.state.roadmap_id
      ? {
        client_id: this.state.clientId,
        road_customization_id: this.state.roadmap_id,
        signature: signature,
        document_template_id: this.state.document_template_id,
        custom_package_id: this.state.package_management_id,
      }
      : {
        client_id: this.state.clientId,
        survey_id: this.state.cfsSurveyId,
        signature: signature,
        document_template_id: this.state.document_template_id,
        package_management_id: this.state.package_management_id,
      };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.saveDocumentSignntureApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_information_onboardings/sign_document`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  saveOnBoardingSurvey = (saved_for_later?= false) => {
    if (this.state.isSavingSurvey) {
      return;
    }
    this.setState({ isSavingSurvey: true });
    this.props.showLoader();
    const headers = {
      "content-type": configJSON.validationApiContentType,
    };
    let package_management_id = null;
    if (this.state.cfsSurveyId) {
      package_management_id = this.state.package_management_id || undefined;
    } else {
      package_management_id = this.state.custom_package_id;
    }
    const data = {
      client_onboarding_survey: {
        package_management_id: this.state.roadmap_id
          ? undefined
          : package_management_id,
        custom_package_management_id: this.state.cfsSurveyId
          ? undefined
          : package_management_id,
        payment_term: this.state.cfsSurveyId
          ? undefined
          : this.state.payment_term,
        survey_id: this.state.cfsSurveyId || undefined,
        saved_for_later: !!saved_for_later,
        road_customization_id: this.state.roadmap_id || undefined,
        allow_to_change_package_id: this.state.allow_to_change_package_id,
      },
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.saveOnBoardingSurveyApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_information_onboardings/${this.state.clientId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PATCH"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  isCheckListComplete = () => {
    let totalQuestionCount = 0;
    let totalAnswerCount = 0;
    this.state.availableCheckList
      .filter((chklist) => {
        return chklist?.id == this.state.selectedCheckListId;
      })
      .forEach((checklist) => {
        checklist?.attributes?.sections?.data?.forEach((section) => {
          section?.attributes?.questions?.data?.forEach((question) => {
            totalQuestionCount++;
            if (
              this.state.onBoadringSurveyChecklistAnswer[
                `checkListId:${this.state.selectedCheckListId}_section:${section?.id}_question:${question?.id}`
              ]?.answer
            ) {
              totalAnswerCount++;
            }
          });
        });
      });
    return totalQuestionCount == totalAnswerCount;
  };

  isCheckListComplete2 = () => {
    const checklist = this.state.availableCheckList.find(
      chk => chk?.id == this.state.selectedCheckListId
    );

    if (!checklist) return false;

    const sections = checklist?.attributes?.sections?.data || [];

    if (sections.length === 0) return false;

    const lastSection = [...sections].sort(
      (a, b) =>
        a.attributes.section_rank - b.attributes.section_rank
    )[sections.length - 1];

    const questions =
      lastSection?.attributes?.questions?.data || [];

    if (questions.length === 0) return false;

    const lastQuestion = [...questions].sort(
      (a, b) =>
        a.attributes.question_rank - b.attributes.question_rank
    )[questions.length - 1];

    return (
      +this.state.currentSection?.id ===
        +lastSection?.id &&
      +this.state.currentQuestion?.id ===
        +lastQuestion?.id
    );
  };

  updateCheckList = () => {
    //
    this.props.showLoader();
    const headers = {
      "content-type": configJSON.validationApiContentType,
      // token: lo,
    };
    const status = this.isCheckListComplete2()
    ? "Complete"
    : "In-Progress";

    const data = {
      checklists: {
        id: +this.state.selectedCheckListId,
        status,
        is_completed: this.isCheckListComplete(),
        sections_attributes: [
          {
            id: +this.state.currentSection?.id,
            questions_attributes: [
              {
                id: +this.state.currentQuestion?.id,
                document: {
                  data: this.state.onBoadringSurveyChecklistAnswer[
                    `checkListId:${this.state.selectedCheckListId}_section:${this.state.currentSection?.id}_question:${this.state.currentQuestion?.id}`
                  ]?.file_base64,
                },
                current_gathered_details: this.state.onBoadringSurveyChecklistAnswer[
                  `checkListId:${this.state.selectedCheckListId}_section:${this.state.currentSection?.id}_question:${this.state.currentQuestion?.id}`
                ]?.answer?.toString(),
              },
            ],
          },
        ],
      },
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateCheckListApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_information_onboardings/${this.state.clientId}/update_checklist`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PATCH"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  // responseJson?.data?.attributes?.package?.data
  getCurrentSection = () => {
    const availableCheckList = this.state.availableCheckList;
    const index = availableCheckList?.findIndex((chkList) => {
      return chkList?.id === this.state.selectedCheckListId;
    });
    const checklist = availableCheckList[index];
    const section =
      checklist?.attributes?.sections?.data[
      this.state.checkListStepperIndex[this.state.selectedCheckListId]
      ];
    this.setState(
      {
        currentSection: section,
      },
      () => {
        this.setState(
          {
            section_question_index: 0,
          },
          () => {
            this.getNextQuestion(true);
          }
        );
      }
    );
  };
  getFirstQuestionOfSection = () => {
    this.setState(
      {
        section_question_index: 0,
      },
      () => {
        const currentSection = { ...this.state.currentSection };
        const questions = currentSection?.attributes?.questions?.data;
        this.setState({
          currentQuestion: questions[this.state.section_question_index],
        });
      }
    );
  };
  getCurrentUnansweredQues = (currentQuestions, temp) => {
    let currentQuestion = null;
    let currentQuestionIndex = 0;
    for (const question of currentQuestions) {
      if (question?.id == temp?.question) {
        currentQuestion = question;
        currentQuestionIndex = currentQuestions?.findIndex((qus) => {
          return qus.id == question.id;
        });
        break;
      }
    }
    return { currentQuestion, currentQuestionIndex };
  };
  getCurrentUnansweredSectionAndQuestion = (checklist, temp) => {
    let currentSection = null;
    let currentSectionIndex = 0;
    let currentQuestion = null;
    let currentQuestionIndex = 0;
    const sections = checklist?.attributes?.sections?.data;
    for (const section of sections) {
      if (section?.id == temp?.section) {
        currentSection = section;
        currentSectionIndex = sections?.findIndex((sec) => {
          return sec.id == section.id;
        });
        const currentQuestions = section?.attributes?.questions?.data;
        const ques = this.getCurrentUnansweredQues(currentQuestions, temp);
        currentQuestion = ques?.currentQuestion;
        currentQuestionIndex = ques?.currentQuestionIndex;
        break;
      }
    }
    return {
      currentSection,
      currentSectionIndex,
      currentQuestion,
      currentQuestionIndex,
    };
  };
  getCurrentUnansweredQuestion = (temp) => {
    const checklists = this.state.checkListDetail;
    let currentChecklist = null;
    let currentSection = null;
    let currentQuestion = null;
    let currentSectionIndex = 0;
    let currentQuestionIndex = 0;
    for (const checklist of checklists) {
      if (checklist?.id == temp?.checkListId) {
        currentChecklist = checklist;
        const sec = this.getCurrentUnansweredSectionAndQuestion(
          checklist,
          temp
        );
        currentSection = sec?.currentSection;
        currentSectionIndex = sec?.currentSectionIndex;
        currentQuestion = sec?.currentQuestion;
        currentQuestionIndex = sec?.currentQuestionIndex;
        break;
      }
    }
    return {
      currentChecklist,
      currentSection,
      currentQuestion,
      currentSectionIndex,
      currentQuestionIndex,
    };
  };
  getUnanswerQuestionifPresent = () => {
    for (const key of Object.keys(this.state.onBoadringSurveyChecklistAnswer)) {
      if (!this.state.onBoadringSurveyChecklistAnswer[key]?.answer) {
        const newchecklist = key.split("_");
        const temp = {};
        newchecklist.forEach((tt) => {
          const a = tt.split(":");
          temp[a[0]] = a[1];
        });
        const ques = this.getCurrentUnansweredQuestion(temp);
        this.setState((prevState) => {
          return {
            selectedCheckListId: ques?.currentChecklist?.id,
            checkListStepperIndex: {
              ...prevState.checkListStepperIndex,
              [+ques?.currentChecklist?.id]: ques?.currentSectionIndex,
            },
            section_question_index: ques?.currentQuestionIndex,
            currentQuestion: ques?.currentQuestion,
            currentSection: ques?.currentSection,
          };
        });
        break;
      }
    }
  };
  getNextQuestion = (isFirst) => {
    if (isFirst) {
      this.getFirstQuestionOfSection();
      this.updateClientStatus("Enrolled");
      this.updateOnboardingSurveyStatus("Enrolled");
    } else {
      const ans = this.state.currentStep === 4
        ? this.getSelectedChecklistQuestionsCount()
        : this.getAllAnsweredQuestionsCount();

      if (ans?.totalAnsweCount == ans?.totalQuestionCount) {
        this.setState(
          {
            currentStep: 5,
          },
          () => {
            this.updateClientStatus("Onboarded");
            this.updateOnboardingSurveyStatus("completed");
          }
        );
      } else {
        this.updateQuestionIndex();
        this.updateClientStatus("Enrolled");
        this.updateOnboardingSurveyStatus("Onboarding");
      }
    }
  };
  updateQuestionIndex = () => {
    this.setState(
      (prevState) => {
        return {
          section_question_index: prevState.section_question_index + 1,
        };
      },
      () => {
        const currentSection = { ...this.state.currentSection };
        if (
          currentSection?.attributes?.questions?.data?.length ===
          this.state.section_question_index
        ) {
          this.handleStepChange();
        } else if (
          this.state.section_question_index >
          currentSection?.attributes?.questions?.data?.length
        ) {
          // At step 4: only count questions from selected checklist
          const ans = this.state.currentStep === 4
            ? this.getSelectedChecklistQuestionsCount()
            : this.getAllAnsweredQuestionsCount();

          if (ans?.totalAnsweCount === ans?.totalQuestionCount) {
            this.setState(
              {
                currentStep: 5,
              },
              () => {
                this.updateOnboardingSurveyStatus("completed");
              }
            );
          } else {
            this.getUnanswerQuestionifPresent();
          }
        } else {
          this.moveToNextQuestion();
        }
      }
    );
  };
  handleStepChange = () => {
    this.setState(
      (prevState) => {
        return {
          checkListStepperIndex: {
            ...prevState.checkListStepperIndex,
            [this.state.selectedCheckListId]:
              this.state.checkListStepperIndex[this.state.selectedCheckListId] +
              1,
          },
        };
      },
      () => {
        this.moveToNextCheckList();
      }
    );
  };
  moveToNextCheckList = () => {
    const availableCheckList = this.state.availableCheckList;
    const index = availableCheckList?.findIndex((chkList) => {
      return chkList?.id == this.state.selectedCheckListId;
    });
    const checklist = availableCheckList[index];
    if (
      this.state.checkListStepperIndex[this.state.selectedCheckListId] ===
      checklist?.attributes?.sections?.data?.length
    ) {
      if (this.state.isDefaultObsFlow) {
        this.setState(
          {
            currentStep: 5,
          },
          () => {
            this.updateOnboardingSurveyStatus("completed");
          }
        );
      }
      else if (index + 1 < availableCheckList.length) {
        const newSelectedChecklist = availableCheckList[index + 1];

        this.setState(
          {
            selectedCheckListId: newSelectedChecklist?.id,
          },
          () => {
            this.getCurrentSection();
          }
        );
      } else if (index + 1 === availableCheckList.length) {
        const ans = this.getAllAnsweredQuestionsCount();
        if (ans?.totalAnsweCount === ans?.totalQuestionCount) {
          this.setState(
            {
              currentStep: 5,
            },
            () => {
              this.updateOnboardingSurveyStatus("completed");
            }
          );
        } else {
          this.getUnanswerQuestionifPresent();
        }
      }
    } else {
      this.moveToNextSection(checklist);
    }
  };
  moveToNextQuestion = () => {
    const currentSection = { ...this.state.currentSection };
    const questions = currentSection?.attributes?.questions?.data;
    this.setState({
      currentQuestion: questions[this.state.section_question_index],
    });
  };
  moveToNextSection = (checklist) => {
    const section =
      checklist?.attributes?.sections?.data[
      this.state.checkListStepperIndex[this.state.selectedCheckListId]
      ];
    this.setState(
      {
        section_question_index: 0,
        currentSection: section,
      },
      () => {
        const currentSection = { ...this.state.currentSection };
        const questions = currentSection?.attributes?.questions?.data;
        this.setState({
          currentQuestion:
            questions?.length > 0
              ? questions[this.state.section_question_index]
              : null,
        });
      }
    );
  };
  getAllAnsweredQuestionsCount = () => {
    const totalQuestionCount = this.state.totalQuestions;
    let totalAnsweCount = 0;
    Object.keys(this.state.onBoadringSurveyChecklistAnswer).forEach(
      (questionKey) => {
        if (this.state.onBoadringSurveyChecklistAnswer[questionKey]?.answer) {
          totalAnsweCount++;
        }
      }
    );
    return { totalQuestionCount, totalAnsweCount };
  };

  getSelectedChecklistQuestionsCount = () => {
    const selectedCheckListId = this.state.selectedCheckListId;
    const selectedChecklist = this.state.availableCheckList?.find(
      (chk) => chk?.id === selectedCheckListId
    );

    if (!selectedChecklist) {
      return { totalQuestionCount: 0, totalAnsweCount: 0 };
    }

    let totalQuestionCount = 0;
    let totalAnsweCount = 0;

    selectedChecklist?.attributes?.sections?.data?.forEach((section) => {
      section?.attributes?.questions?.data?.forEach((question) => {
        totalQuestionCount++;

        const questionKey = `checkListId:${selectedCheckListId}_section:${section?.id}_question:${question?.id}`;
        if (this.state.onBoadringSurveyChecklistAnswer[questionKey]?.answer) {
          totalAnsweCount++;
        }
      });
    });

    return { totalQuestionCount, totalAnsweCount };
  };
  goToPriviousSection = (sectionIndex: number) => {
    const availableCheckList = [...this.state.availableCheckList];
    const index = availableCheckList?.findIndex((chkList) => {
      return chkList?.id == this.state.selectedCheckListId;
    });
    const checklist = availableCheckList[index];
    const section = checklist?.attributes?.sections?.data[sectionIndex];
    this.setState(
      (prevState) => {
        return {
          checkListStepperIndex: {
            ...prevState.checkListStepperIndex,
            [this.state.selectedCheckListId]: sectionIndex,
          },
        };
      },
      () => {
        this.setState(
          {
            section_question_index: 0,
            currentSection: section,
          },
          () => {
            const currentSection = { ...this.state.currentSection };
            const questions = currentSection?.attributes?.questions?.data;
            this.setState({
              currentQuestion: questions[this.state.section_question_index],
            });
          }
        );
      }
    );
  };
  getAnswerOfEachQuestion = (checklists: any) => {
    const onBoadringSurveyChecklistAnswer = {};
    let totalQuestionCount = 0;
    let totalAnswerCount = 0;
    let count = 0;
    checklists.forEach((checklist) => {
      checklist?.attributes?.sections?.data?.forEach((section) => {
        section?.attributes?.questions?.data?.forEach((question) => {
          totalQuestionCount++;
          count++;
          if (question?.attributes?.current_gathered_details) {
            totalAnswerCount++;
          }
          onBoadringSurveyChecklistAnswer[
            `checkListId:${checklist?.id}_section:${section?.id}_question:${question?.id}`
          ] = {
            count,
            answer:
              (question?.attributes?.current_gathered_details?.indexOf(",") > -1
                ? question?.attributes?.current_gathered_details?.split(",")
                : question?.attributes?.current_gathered_details) || "",
            additional_notes: question?.attributes?.additional_notes || "",
            document: question?.attributes?.document,
          };
        });
      });
    });
    return {
      totalQuestionCount,
      totalAnswerCount,
      onBoadringSurveyChecklistAnswer,
    };
  };
  updateOnboardingSurveyStatus = (status: string) => {
    if (this.state.cfsSurveyId) {
      this.props.showLoader();

      const headers = {
        "content-type": "application/json",
      };
      const data = {
        survey_status: status,
        survey_id: this.state.cfsSurveyId || "",
      };

      const requestMessage = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );

      this.updateOnboardingSurveyStatusCallId = requestMessage.messageId;

      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        `bx_block_pricingcalculator/client_information_onboardings/update_suvey`
      );

      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(headers)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(data)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        "PATCH"
      );

      runEngine.sendMessage(requestMessage.id, requestMessage);
    }
  };
  updateClientStatus = (status: string) => {
    const headers = {
      "content-type": "application/json",
    };
    const data = {
      id: this.state.clientId,
      account_id: this.state.accountId,
      status,
      onboarding_date: moment().format("YYYY-MM-DD"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateClientStatusCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_clients/client_informations/update_client_status`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  createChecklistforSelectedPackage = (package_management_id: number) => {
    if (this.state.isCreatingChecklist) {
      return;
    }

    this.setState({
      isCreatingChecklist: true,
      checklistCreationAttempted: true
    });
    this.props.showLoader();

    const headers = {
      "content-type": "application/json",
      token: this.state.token,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createChecklistforSelectedPackageApiCallId = requestMessage.messageId;

    const endpoint = `bx_block_pricingcalculator/client_informations/${this.state.clientId}/create_checklists`;

    let payload: any = {
      package_management_id: package_management_id,
      account_id: this.state.accountId,
    };

    if (this.state.cfsSurveyId) {
      payload.survey_id = this.state.cfsSurveyId;
    }

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(payload)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  saveForLater = () => {
    this.props.showLoader();
    const headers = {
      "content-type": configJSON.validationApiContentType,
      // token: lo,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.saveForLaterApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_information_onboardings/save_for_later?id=${this.state.onboarding_survey_id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({})
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  // Default OBS flow methods
  setValueByDynamicName = (name: string, value: any) => {
    this.setState({
      [name]: value,
    } as Pick<S, keyof S>);
  };

  createClientForDefaultObs = () => {
    this.props.showLoader();
    const headers = {
      "content-type": configJSON.validationApiContentType,
    };

    const data = {
      about_us_attributes: {
        first_name: this.state.firstName || "",
        last_name: this.state.lastName || "",
        email: this.state.email || "",
        phone: this.state.phoneNumber || "",
        country_code: this.state.country_code || "+1",
        account_id: this.state.accountId,
        survey_type: 1,
        answer: [],
        no_cfs_survey: true,
      },
      account_id: this.state.accountId,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createClientForDefaultObsApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_survey/surveys`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCreateClientForDefaultObsResponse = (responseJson: any) => {
    this.props.hideLoader();
    if (responseJson?.data?.id) {
      const clientId = responseJson.data.attributes.client_info_s?.id;
      const surveyId = responseJson.data.id;

      const packages = responseJson.data.attributes.packages;
      const PackageId = packages?.id || PackageManagementId.DEFAULT_OBS;
      if (this.state.isDefaultObsFlow) {
        sessionStorage.setItem('defaultObsSurveyId', surveyId.toString());
        sessionStorage.setItem('defaultObsClientId', clientId?.toString());
      }

      this.setState(
        {
          clientId: clientId,
          cfsSurveyId: surveyId,
          currentStep: 1,
          package_management_id: PackageId,
        },
        () => {
          if (PackageId) {
            this.createChecklistforSelectedPackage(PackageId);
          }
          this.getSignatureRequest();
        }
      );
    } else {
      this.handleApiError(responseJson);
    }
  };

  handleDefaultObsClientInfoSubmit = () => {
    this.createClientForDefaultObs();
  };

  getClientDetailsForDefaultObs = () => {
    this.props.showLoader();
    const headers = {
      "content-type": "application/json",
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getClientDetailsForDefaultObsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_pricingcalculator/client_informations/${this.state.clientId}/get_client_details`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleGetClientDetailsForDefaultObsResponse = (responseJson: any) => {
    this.props.hideLoader();
    if (responseJson?.data?.attributes) {
      const clientData = responseJson.data.attributes;
      this.setState({
        firstName: clientData.first_name || "",
        lastName: clientData.last_name || "",
        email: clientData.primary_email || "",
        phoneNumber: clientData.primary_phone || "",
        country_code: clientData.primary_country_code || "+1",
        hasExistingClientData: true,
        currentStep: -1,
        isLoadingPage: false,
      });
    } else {
      // If client details not found, show empty form
      this.setState({
        hasExistingClientData: false,
        currentStep: -1,
        isLoadingPage: false,
      });
    }
  };
}
// Customizable Area End